import { createTheme } from '@mui/material/styles';
import { deepmerge } from '@mui/utils';
import { typographyOptions, paletteOptions, componentsOptions, breakpointsOptions, shadowsOptions, } from './index';
export var lightModernTheme = createTheme([typographyOptions, paletteOptions, componentsOptions, breakpointsOptions, shadowsOptions].reduce(function (acc, option) { return deepmerge(acc, option); }, // deepmerge excepts only two params
{}));
// Default MUI theme values: https://mui.com/material-ui/customization/default-theme/
